import type { NegativeNews, NegativeNewsReviewStatus } from '@gcv/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { NegativeNewsApi } from 'api';
import { updateNegativeNewsCache } from 'tanstack-hooks/fi-negative-news/negative-news-cache';
import { NEGATIVE_NEWS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useSetNegativeNewsReviewStatus(negativeNewsRecord: NegativeNews) {
  const { user } = useUser();
  const negativeNewsApi = new NegativeNewsApi();
  const queryClient = useQueryClient();

  const { mutate: setNegativeNewsReviewStatus } = useMutation({
    mutationKey: [NEGATIVE_NEWS_KEY],
    mutationFn: (variables: { reviewStatus: NegativeNewsReviewStatus; reviewNote: string }) =>
      negativeNewsApi.setReviewStatus(
        negativeNewsRecord.source_story_id,
        negativeNewsRecord.sp_id,
        negativeNewsRecord.crb_id,
        variables.reviewStatus,
        variables.reviewNote
      ),
    onSuccess: (_data, variables) => {
      updateNegativeNewsCache(queryClient, negativeNewsRecord, {
        review_status: variables.reviewStatus,
        review_note: variables.reviewNote,
        review_date: new Date().toISOString(),
        reviewed_by: user?.id
      });
    },
    meta: {
      snackbarErrorMessage:
        'There was an issue updating the review status. Please contact support if the problem persists.'
    }
  });

  return { setNegativeNewsReviewStatus };
}
